import './styles.scss';

type StepperItem = { text: string };

type StepperProps = { steppers: StepperItem[]; step: number };

export const Stepper = ({ steppers, step }: StepperProps) => {
	return (
		<div className="steppers">
			{steppers.map((stepper, index) => (
				<div
					className={`stepper ${index + 1 <= step && 'border'} ${index + 1 < step && 'menor'} ${
						index + 1 === step && 'igual'
					} ${index + 1 > step && 'mayor'}`}
					key={index}
				>
					<div className="stepper__circle">{index + 1}</div>
					<div className="step">{stepper.text}</div>
				</div>
			))}
		</div>
	);
};
